var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"unauthorized"}},[_c('div',{staticClass:"container-fluid pt-4"},[_c('div',{staticClass:"section-title"},[_vm._v("\n      Xml Import Rules\n    ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('Rules')],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c132d84","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/xmlimport/RulesDashboard.vue
// module id = 896
// module chunks = 0